import AcreSpinner from 'components/Common/AcreSpinner';
import Filter from 'domain/property/Filter';
import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'utils/wrappers';
import '../../styles/SearchToolbar.scss';
import FilterBoxContainer from './Part/FilterBox';
import { Button } from 'reactstrap';
import SpinnerButton from 'components/Common/SpinnerButton/SpinnerButton';

const SearchToolbar = ({
    availableFilters,
    onClearFilters,
    onApplyFilters,
    backendFilters,
    categories,
    toggleFiltersVisibility,
    areFiltersVisible,
    searchedPropertiesLoading,
}) => {
    if (backendFilters.areLoading || categories.areLoading) {
        return <AcreSpinner wrapped={true} />;
    }

    const statesFilter = new Filter(backendFilters.states);
    const states = statesFilter.toOptions();
    const countiesFilter = new Filter(backendFilters.counties);
    const counties = countiesFilter.toOptions();
    const propertyTypes = backendFilters.propertyTypes.map((type) => ({ label: type.name, value: type.id }));

    return (
        <div className={'filters-container'}>
            <div className={'filters'}>
                <FilterBoxContainer title={'State'} content={states} filterSlug={'state'} isClosed={true} />
                <FilterBoxContainer title={'County'} content={counties} filterSlug={'county'} isClosed={true} />
                <FilterBoxContainer title={'Property type'} content={propertyTypes} filterSlug={'propertyType'} />
                <Button color={'white'} className={'filterSize'} onClick={toggleFiltersVisibility}>
                    More Filters{' '}
                    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <g>
                            <path
                                clipPath='url(#clip0_11_2716)'
                                d='M11.6364 2.25C11.6364 1.80499 11.7643 1.36998 12.0041 0.999968C12.2438 0.629957 12.5846 0.341569 12.9832 0.171272C13.3819 0.000974893 13.8206 -0.0435826 14.2438 0.0432341C14.6671 0.130051 15.0558 0.344343 15.361 0.659011C15.6661 0.973679 15.8739 1.37459 15.9581 1.81105C16.0423 2.2475 15.9991 2.6999 15.8339 3.11104C15.6688 3.52217 15.3891 3.87357 15.0303 4.12081C14.6715 4.36804 14.2497 4.5 13.8182 4.5C13.2395 4.5 12.6846 4.26295 12.2754 3.84099C11.8662 3.41903 11.6364 2.84674 11.6364 2.25ZM0.727273 3H9.45455C9.64743 3 9.83241 2.92098 9.9688 2.78033C10.1052 2.63968 10.1818 2.44891 10.1818 2.25C10.1818 2.05109 10.1052 1.86032 9.9688 1.71967C9.83241 1.57902 9.64743 1.5 9.45455 1.5H0.727273C0.534388 1.5 0.349403 1.57902 0.213013 1.71967C0.0766231 1.86032 0 2.05109 0 2.25C0 2.44891 0.0766231 2.63968 0.213013 2.78033C0.349403 2.92098 0.534388 3 0.727273 3ZM5.09091 5.25C4.64077 5.2513 4.20204 5.39616 3.83486 5.6647C3.46769 5.93325 3.19005 6.31234 3.04 6.75H0.727273C0.534388 6.75 0.349403 6.82902 0.213013 6.96967C0.0766231 7.11032 0 7.30109 0 7.5C0 7.69891 0.0766231 7.88968 0.213013 8.03033C0.349403 8.17098 0.534388 8.25 0.727273 8.25H3.04C3.17342 8.63916 3.40808 8.98297 3.71829 9.2438C4.0285 9.50464 4.40231 9.67245 4.79881 9.72887C5.19531 9.78529 5.59922 9.72814 5.96633 9.56369C6.33345 9.39923 6.64962 9.1338 6.88025 8.79644C7.11088 8.45909 7.24708 8.06281 7.27394 7.65097C7.30079 7.23914 7.21728 6.82762 7.03253 6.46145C6.84779 6.09529 6.56893 5.78859 6.22647 5.57492C5.88402 5.36125 5.49116 5.24884 5.09091 5.25ZM15.2727 6.75H9.45455C9.26166 6.75 9.07668 6.82902 8.94029 6.96967C8.8039 7.11032 8.72727 7.30109 8.72727 7.5C8.72727 7.69891 8.8039 7.88968 8.94029 8.03033C9.07668 8.17098 9.26166 8.25 9.45455 8.25H15.2727C15.4656 8.25 15.6506 8.17098 15.787 8.03033C15.9234 7.88968 16 7.69891 16 7.5C16 7.30109 15.9234 7.11032 15.787 6.96967C15.6506 6.82902 15.4656 6.75 15.2727 6.75ZM6.54545 12H0.727273C0.534388 12 0.349403 12.079 0.213013 12.2197C0.0766231 12.3603 0 12.5511 0 12.75C0 12.9489 0.0766231 13.1397 0.213013 13.2803C0.349403 13.421 0.534388 13.5 0.727273 13.5H6.54545C6.73834 13.5 6.92332 13.421 7.05971 13.2803C7.1961 13.1397 7.27273 12.9489 7.27273 12.75C7.27273 12.5511 7.1961 12.3603 7.05971 12.2197C6.92332 12.079 6.73834 12 6.54545 12ZM15.2727 12H12.96C12.7884 11.4996 12.4509 11.0778 12.0069 10.8093C11.563 10.5407 11.0413 10.4426 10.534 10.5324C10.0267 10.6222 9.56657 10.8939 9.23483 11.2998C8.90309 11.7056 8.72114 12.2192 8.72114 12.75C8.72114 13.2808 8.90309 13.7944 9.23483 14.2002C9.56657 14.606 10.0267 14.8778 10.534 14.9676C11.0413 15.0573 11.563 14.9593 12.0069 14.6907C12.4509 14.4222 12.7884 14.0004 12.96 13.5H15.2727C15.4656 13.5 15.6506 13.421 15.787 13.2803C15.9234 13.1397 16 12.9489 16 12.75C16 12.5511 15.9234 12.3603 15.787 12.2197C15.6506 12.079 15.4656 12 15.2727 12Z'
                                fill='#71B893'
                            />
                        </g>
                        <defs>
                            <clipPath id='clip0_11_2716'>
                                <rect width='16' height='16' fill='white' transform='matrix(-1 0 0 -1 16 16)' />
                            </clipPath>
                        </defs>
                    </svg>
                </Button>
                <div className={'grow'}></div>
                <SpinnerButton
                    className={'search-button filterSize'}
                    isLoading={searchedPropertiesLoading}
                    color={'primary'}
                    onClick={onApplyFilters}
                >
                    Search
                </SpinnerButton>
            </div>
            <div className={'filters ' + (areFiltersVisible ? 'visible' : 'hidden')}>
                <div className={'tick'}></div>
                {availableFilters.map((filter, index) => (
                    <FilterBoxContainer
                        key={index}
                        title={filter.title}
                        content={filter.values}
                        filterSlug={filter.slug}
                        isClosed={filter.isClose}
                    />
                ))}
                <FilterBoxContainer
                    title={'Financing'}
                    content={backendFilters.financing.map((type, index) => {
                        return { label: type.name, value: type.id };
                    })}
                    filterSlug={'financing'}
                />
                <FilterBoxContainer
                    title={'Category'}
                    content={categories.data.map((category) => {
                        return { label: category.name, value: category.slug };
                    })}
                    filterSlug={'category'}
                />
            </div>
        </div>
    );
};

SearchToolbar.propTypes = {
    backendFilters: PropTypes.shape({
        counties: PropTypes.array.isRequired,
        states: PropTypes.array.isRequired,
        propertyTypes: PropTypes.array.isRequired,
        financing: PropTypes.array.isRequired,
    }).isRequired,
    availableFilters: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            slug: PropTypes.string.isRequired,
            values: PropTypes.arrayOf(
                PropTypes.shape({
                    label: PropTypes.string.isRequired,
                    value: PropTypes.string.isRequired,
                }),
            ).isRequired,
            isClose: PropTypes.bool,
        }),
    ).isRequired,
    onApplyFilters: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired,
    toggleFiltersVisibility: PropTypes.func.isRequired,
    areFiltersVisible: PropTypes.bool.isRequired,
    searchedPropertiesLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
    backendFilters: state.backendPropertiesFilters,
    categories: state.propertyCategories,
    searchedPropertiesLoading: state.searchedProperties.areLoading,
});

export default connect(mapStateToProps, null)(SearchToolbar);
